<app-portal-collapsible
    [title]="title()"
    [subtitle]="subtitle()"
    [icon]="icon()"
    [alert]="subtitleAlert()"
>
    @if (!isComplete()) {
        <i
            collapsibleHeading
            class="c:red"
            ctrlIcon="warning"
            aria-label="Nicht vollständing"
        ></i>
    }
    <app-portal-device-details
        [device]="device()"
        (submitDetails)="submit($event)"
    />
</app-portal-collapsible>
